import * as P from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as no } from "../../helpers/edgeMask.js";
const ao = {
  name: "ChromaticSoft1",
  collection: "chromatic-soft",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: l,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: c,
      uv: N,
      color: t
    } = P, S = t("#c68c21"), _ = t("#ffb700"), p = t("#ba23f6"), u = t("#2b84ff"), C = t("#657dfa"), R = t("#9051ad"), D = 0, G = 2, I = 0, L = 0, g = 0.2, A = 0.5, b = 2, F = 0.2, v = 0.05, w = 1, U = 0.6, Y = 0.5, x = 1, V = 1, s = N(), { correctedUV: W } = Z(), a = oo(s, g, A, b), h = c(S, o(2.2)), y = c(_, o(2.2)), B = c(p, o(2.2)), k = c(u, o(2.2)), H = n(
      h,
      y,
      s.x
    ), K = n(
      k,
      B,
      s.x
    ), Q = n(
      H,
      K,
      s.y
    ), d = a.x.sub(0.5), i = a.y.sub(0.5), X = i.mul(d).add(i.mul(d)).negate(), r = o(1).add(
      o(F).mul(
        T(
          X.add(O.mul(m.speed.uniform).mul(0.025)).div(v)
        )
      )
    ), z = no({
      inset: D,
      softness: G,
      offsetX: I,
      offsetY: L
    }), M = E(r, r, r).mul(z).mul(w), j = n(
      R,
      C,
      s.y
    ), f = $(U)(W), e = Q.mul(M).add(f), q = e.r.add(e.g).add(e.b), J = l(
      n(j.add(f), e, q),
      1
    );
    return to(J, _, Y, x, V);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
